export const permissionKeys = {
  all: ['permissions'] as const,
  mine: (): readonly string[] => [...permissionKeys.all, 'me'] as const,
};
